import { useEffect } from 'react';
import BasePage from './BasePage';
import { Box, Container, Typography, Paper, Breadcrumbs, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

function PrivacyPolicy() {
  useEffect(() => {
    // Load the Termly script
    const script = document.createElement('script');
    script.id = 'termly-jssdk';
    script.src = 'PrivacyPolicy.js'; // 'https://app.termly.io/embed-policy.min.js';
    script.async = true;
    document.body.appendChild(script);
    
    return () => {
      const script = document.getElementById('termly-jssdk');
      if (script) {
        script.remove();
      }
    };
  }, []);

  return (
    <BasePage
      title="CribCritic Privacy Policy"
      description="Privacy Policy for CribCritic AI"
      keywords="privacy policy, data protection, user privacy"
      canonicalUrl="https://cribcritic.ai/privacy-policy"
    >
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Breadcrumbs sx={{ mb: 3 }}>
          <Link 
            component={RouterLink} 
            to="/" 
            underline="hover" 
            color="inherit"
            zIndex={2001}
            sx={{ 
              '&:hover': { 
                color: 'primary.main',
                cursor: 'pointer' 
              },
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Box component="span" sx={{ display: 'flex', alignItems: 'center' }}>
              {/* Optional: Add home icon */}
              Home
            </Box>
          </Link>
          <Typography color="text.primary">Privacy Policy</Typography>
        </Breadcrumbs>
        
        <Paper elevation={2} sx={{ p: { xs: 0, md: 0 }, borderRadius: 2 }}>          
          {/* Termly Privacy Policy Embed using dangerouslySetInnerHTML */}
          <Box 
            sx={{ width: '100%' }}
            dangerouslySetInnerHTML={{
              __html: '<div name="termly-embed" data-id="e6541aef-49f8-4cc3-8871-e2a65f699029"></div>'
            }}
          />
        </Paper>
      </Container>
    </BasePage>
  );
}

export default PrivacyPolicy;